export default __webpack_public_path__ + "static/media/dropup-blue.f6e32089.svg";